import { render, staticRenderFns } from "./MenuModular.vue?vue&type=template&id=c289624e&scoped=true&"
import script from "./MenuModular.vue?vue&type=script&lang=js&"
export * from "./MenuModular.vue?vue&type=script&lang=js&"
import style0 from "./MenuModular.vue?vue&type=style&index=0&id=c289624e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c289624e",
  null
  
)

export default component.exports